import React, { useState } from 'react'
import PropTypes from 'prop-types'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import CloseIcon from '@material-ui/icons/Close'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Dialog from '@material-ui/core/Dialog'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import IconButton from '@material-ui/core/IconButton'
import MarkerIcon from '@material-ui/icons/Room'
import DeleteIcon from '@material-ui/icons/Delete'
import Slide from '@material-ui/core/Slide'

import LocationMap from '../LocationMap'
import { styles } from './styles'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export const LocationList = ({
  locations,
  setUpdateLocations,
  setDeleteLocations
}) => {
  const [open, setOpen] = useState(false)
  const [location, setLocation] = useState({ id: null, lat: 0, lng: 0 })

  const removeLocations = (locationId) => {
    setDeleteLocations(locationId)
  }

  const handleUpdateLocation = () => {
    setUpdateLocations(location)
    setOpen(false)
  }

  if (locations.length > 0) {
    return (
      <React.Fragment>
        <List component="nav">
          {locations &&
            locations.map((item, index) => (
              <ListItem
                key={index.toString()}
                button
                onClick={() => {
                  setLocation(item)
                  setOpen(true)
                }}>
                <ListItemIcon>
                  <MarkerIcon />
                </ListItemIcon>
                <ListItemText
                  primary={`${item.lat}, ${item.lng}`}
                  secondary={item.address}
                />
                <ListItemSecondaryAction>
                  <IconButton
                    aria-label="Delete"
                    onClick={() => removeLocations(item.locationId)}>
                    <DeleteIcon color="secondary" />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
        </List>
        <Dialog fullScreen open={open} TransitionComponent={Transition}>
          <AppBar position="sticky">
            <Toolbar style={styles.toolbar}>
              <IconButton
                id="btnClose"
                color="inherit"
                aria-label="Menu"
                style={styles.menuButton}
                onClick={() => setOpen(false)}>
                <CloseIcon />
              </IconButton>
              <Typography
                id="titlePage"
                variant="h6"
                color="inherit"
                style={styles.grow}>
                Pick your location
              </Typography>
              <Button
                id="btnLocationAdd"
                color="inherit"
                aria-label="Update"
                style={styles.userButton}
                onClick={() => handleUpdateLocation()}>
                <Typography color="inherit">UPDATE</Typography>
              </Button>
            </Toolbar>
          </AppBar>
          <LocationMap
            location={location}
            setLocation={(data) => {
              setLocation({ locationId: location.locationId, ...data })
            }}
          />
        </Dialog>
      </React.Fragment>
    )
  } else {
    return <div />
  }
}

LocationList.propTypes = {
  locations: PropTypes.array.isRequired,
  setUpdateLocations: PropTypes.func.isRequired,
  setDeleteLocations: PropTypes.func.isRequired
}

export default LocationList



// WEBPACK FOOTER //
// ./src/components/LocationList/index.js